// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgListviewLine24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M5.5 3.75C5.91421 3.75 6.25 4.08579 6.25 4.5C6.25 4.91421 5.91421 5.25 5.5 5.25H3.5C3.08579 5.25 2.75 4.91421 2.75 4.5C2.75 4.08579 3.08579 3.75 3.5 3.75H5.5ZM20.5 3.75C20.9142 3.75 21.25 4.08579 21.25 4.5C21.25 4.91421 20.9142 5.25 20.5 5.25H8.5C8.08579 5.25 7.75 4.91421 7.75 4.5C7.75 4.08579 8.08579 3.75 8.5 3.75H20.5ZM5.5 8.75C5.91421 8.75 6.25 9.08579 6.25 9.5C6.25 9.91421 5.91421 10.25 5.5 10.25H3.5C3.08579 10.25 2.75 9.91421 2.75 9.5C2.75 9.08579 3.08579 8.75 3.5 8.75H5.5ZM20.5 8.75C20.9142 8.75 21.25 9.08579 21.25 9.5C21.25 9.91421 20.9142 10.25 20.5 10.25H8.5C8.08579 10.25 7.75 9.91421 7.75 9.5C7.75 9.08579 8.08579 8.75 8.5 8.75H20.5ZM6.25 14.5C6.25 14.0858 5.91421 13.75 5.5 13.75H3.5C3.08579 13.75 2.75 14.0858 2.75 14.5C2.75 14.9142 3.08579 15.25 3.5 15.25H5.5C5.91421 15.25 6.25 14.9142 6.25 14.5ZM21.25 14.5C21.25 14.0858 20.9142 13.75 20.5 13.75H8.5C8.08579 13.75 7.75 14.0858 7.75 14.5C7.75 14.9142 8.08579 15.25 8.5 15.25H20.5C20.9142 15.25 21.25 14.9142 21.25 14.5ZM5.5 18.75C5.91421 18.75 6.25 19.0858 6.25 19.5C6.25 19.9142 5.91421 20.25 5.5 20.25H3.5C3.08579 20.25 2.75 19.9142 2.75 19.5C2.75 19.0858 3.08579 18.75 3.5 18.75H5.5ZM20.5 18.75C20.9142 18.75 21.25 19.0858 21.25 19.5C21.25 19.9142 20.9142 20.25 20.5 20.25H8.5C8.08579 20.25 7.75 19.9142 7.75 19.5C7.75 19.0858 8.08579 18.75 8.5 18.75H20.5Z"
				/>
			</Svg>
		);
	}
);
SvgListviewLine24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgListviewLine24;
